import React from 'react';

import Typography from '@material-ui/core/Typography';

export function OperationsSection() {
  return <Typography paragraph>This is the operations section</Typography>;
}
